module.exports = __webpack_public_path__ + "static/media/gunshot.cf3eceba.svg";